import { useEffect } from 'react';
import { computeTextWidth, defaultSettings, useIsDarkMode, watermark } from '@flowus/common';
import { useCurrentUser } from '../user';
import { useUserName } from '../user/use-remark-name';
import { useSpaceSecurityState } from './use-space-security-state';
import { $searchParams } from 'src/utils';

/**
 * 只有团队版开启了才有效
 */
export const useOpenWatermark = (spaceId?: string) => {
  const user = useCurrentUser();
  const isDarkMode = useIsDarkMode();
  const userName = useUserName(user.uuid);
  const openWatermark = useSpaceSecurityState('openWatermark', spaceId);
  useEffect(() => {
    const tag = user.uuid ? userName + user.phone.slice(-4) : '访客';
    const textWidth = computeTextWidth(tag, {
      fontSize: defaultSettings.watermark_fontsize,
      font: defaultSettings.watermark_font,
      textAlign: 'center',
      display: 'block',
    });
    if (openWatermark) {
      const print = !!$searchParams.print;
      watermark.load({
        watermark_x_space: 50,
        watermark_y_space: 50,
        watermark_angle: 20,
        watermark_width: textWidth,
        watermark_color: isDarkMode ? 'white' : 'black',
        watermark_alpha: print ? 0.1 : isDarkMode ? 0.015 : 0.03,
        watermark_txt: tag,
        print,
      });
    } else {
      watermark.remove();
    }
  }, [isDarkMode, openWatermark, userName, user.uuid, user.phone]);
};
